import { useEffect, useState } from 'react';
import { Typography } from '@mui/material'
import { authenticateToDirectoryOrRedirect } from '@promethee/authentication';
import { Box } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { deserializeErrors} from 'apollo-client'
import { useUser, useSites } from 'store'
import useActions from '../use-actions'

import { OPERATION_ME } from '../Me'


const OPERATION_SITE = gql`
  query FindSiteById($id: ID!) {
    site: findSiteById(id: $id) {
      sf_id
    }
  }
`

const OPERATION_HOTSPOT = gql`
  query FindSiteByHotspotId($id: ID!) {
    site: findSiteByHotspotId(id: $id) {
      sf_id
    }
  }
`

const OPERATION_TREE = gql`
  query AccountsTree($sf_id: String!) {
    accounts: accountsTree(sf_id: $sf_id, with_parent: true) {
      id
      name
      hierarchie
      sf_parent_id  
      sf_id
      nb_children
      is_site
    }
  }
`

const Loading = () => {
  const {t} = useTranslation()
  return (
    <Typography variant={'caption'}>{t('ui_elements.authentication_process')}</Typography>
  )
}

const Redirect = () => {
  const [searchParams] = useSearchParams()
  const [, setSites] = useSites()
  const navigate = useNavigate()
  const {data: dataSite, error: errorSite} = useQuery(searchParams.get('site') ? OPERATION_SITE : OPERATION_HOTSPOT, {
    variables: {
      id: searchParams.get('site') || searchParams.get('hotspot'),
    }
  })
  const {data: dataAccounts, error: errorAccounts} = useQuery(OPERATION_TREE, {
    variables: {
      sf_id: dataSite ? dataSite.site.sf_id : null,
    },
    skip: !dataSite
  })

  useEffect(() => {
    if (dataAccounts) {
      const site = dataAccounts.accounts.find(({sf_id}) => dataSite.site.sf_id === sf_id)
      setSites(prev => ({...prev, selected: [site], accounts: dataAccounts.accounts}))
      navigate('/')
    }
  }, [dataAccounts])

  return errorSite || errorAccounts
    ? <Typography variant={'caption'}>{deserializeErrors(errorSite || errorAccounts)}</Typography>
    : <Loading />
}

const SSO = () => {
  const [user, setUser] = useUser()
  const [ready, setReady] = useState(false)
  const [error, setError] = useState(null);
  const { sso } = useActions()
  const {data} = useQuery(OPERATION_ME, {
    skip: !ready
  })
  useEffect(() => {
    sso()
      .then(() => setReady(true))
      .catch(e => setError(deserializeErrors(e)))
  }, []);
  useEffect(() => {
    if (data) {
      setUser(data.me)
    }
  }, [data])
  return error
    ? <Typography variant={'caption'}>{error}</Typography>
    : user
      ? <Redirect />
      : <Loading />
};

const ExternalApp = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      await authenticateToDirectoryOrRedirect({
        authentUrl: process.env.REACT_APP_AUTH_URL,
        env: process.env.NODE_ENV,
        appName: process.env.REACT_APP_AUTH_APP_NAME,
        jwt: process.env.REACT_APP_AUTH_JWT,
      });
      setReady(true);
    })();
  }, []);
  return (
    <Box
      width={'100%'}
      height={'100vh'}
      display={'flex'}
      alignItems={'center'}
      justifyContent="center"
    >
      {ready ? <SSO /> : <Loading /> }
    </Box>
  );
};

export default ExternalApp
